import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import FormTitle from '@department-of-veterans-affairs/platform-forms-system/FormTitle';
import { focusElement } from '@department-of-veterans-affairs/platform-utilities/ui';
import { isLoggedIn } from '@department-of-veterans-affairs/platform-user/selectors';
import { scrollToTop } from 'platform/utilities/scroll';

import NewIntroContent from './NewIntroContent';
import { ITF_NOTICE_TEXT } from '../constants/entryConstants';
import { resetScreenerSession } from '../../all-claims/subtask/screenerSession';

// Introduction page for the 526 form. Builds the save-in-progress props from
// the route's formConfig and renders the shared introduction content.
export default function IntroductionPage({ route }) {
  const { formConfig, pageList } = route;
  const loggedIn = useSelector(isLoggedIn);

  useEffect(() => {
    // Entering the form from here, not the screener, means Back returns here.
    resetScreenerSession();
    focusElement('h1');
    scrollToTop();
  }, []);

  const sipProps = {
    hideUnauthedStartLink: true,
    headingLevel: 2,
    prefillEnabled: formConfig.prefillEnabled,
    formId: formConfig.formId,
    formConfig,
    pageList,
    startText: 'Start your disability compensation application',
    downtime: formConfig.downtime,
    retentionPeriod: '1 year',
    ariaDescribedby: 'main-content',
    buttonAriaDescribedby: ITF_NOTICE_TEXT,
  };

  return (
    <div className="schemaform-intro" data-form-version={formConfig.formId}>
      <FormTitle title="Apply for VA disability compensation" />
      <p>
        Application for Disability Compensation and Related Compensation
        Benefits (VA Form 21-526EZ)
      </p>
      <NewIntroContent sipProps={sipProps} loggedIn={loggedIn} />
    </div>
  );
}

IntroductionPage.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.object,
    pageList: PropTypes.array,
  }),
};
